import { Injectable } from "@angular/core";
import { Receipt } from "../types/receipt";
import { StorageService } from "./storage.service";
import { UtilsService } from "./utils";
import {RestolutionService} from "./restolution";
import {EventsService} from "./events.service";
import {interval} from "rxjs";
import { Logger, LoggingService } from "ionic-logging-service";
import * as moment from "moment";

@Injectable()
export class ReceiptStore {

  sentReceipts: Receipt[];
  unsentReceipts: Receipt[];
  subs = [];

  private logger: Logger;

  constructor(private utils: UtilsService,
              private storage: StorageService,
              private resto: RestolutionService,
              private events: EventsService,
              private loggingService: LoggingService) {
    this.logger = loggingService.getLogger("BestoGo.ReceiptStore");
    this.sentReceipts = [];
    this.unsentReceipts = [];
    this.getReceipts();
    this.subs.push(
      this.events.getObservable().subscribe((msg) => {
        this.logger.debug("constructor", "Got ws data", msg);
        if (msg) {
          if (msg.type === "PopupSendReceiptsResponse") {
            this.logger.debug("constructor", "Got receipt response: ", msg);
            if (msg.data && msg.data.receipts) {
              this.markReceiptsAsSent(msg);
            }
          }
        }
      }),
    );
    this.subs.push(
      interval(20000).subscribe(x => {
        if(this.unsentReceipts && this.unsentReceipts.length > 0) {
          this.resto.sendReceipts(this.unsentReceipts);
        }
      }));
  }

  async getReceipts() {
    const sentReceipts = await this.storage.get("sentReceipts");
    const unsentReceipts = await this.storage.get("unsentReceipts");
    if (sentReceipts !== null) {
      this.sentReceipts = sentReceipts;
      this.sentReceipts = this.sentReceipts
        .filter((receipt) => receipt.clientID === this.resto.currentLogin.clientId)
        .filter((receipt) => moment(receipt.date).isAfter(moment().subtract(30, "days")));
    }
    if (unsentReceipts !== null) {
      this.unsentReceipts = unsentReceipts;
      this.unsentReceipts = this.unsentReceipts
        .filter((receipt) => receipt.clientID === this.resto.currentLogin.clientId);
      this.storage.set("unsentReceipts", this.unsentReceipts);
    }
  }

  public addReceiptForSending(r: Receipt) {
    this.unsentReceipts.push(r);
    this.writeToStorage();
    this.resto.sendReceipts(this.unsentReceipts);
  }

  public writeToStorage() {
    this.storage.set("sentReceipts", this.sentReceipts);
    this.storage.set("unsentReceipts", this.unsentReceipts);
  }

  public getAllReceipts(): Receipt[] {
    return this.sentReceipts.concat(this.unsentReceipts).sort(this.utils.dynamicSortFn("date")).reverse();
  }

  public getFilteredReceipts(filterFn, ...args): Receipt[] {
    return this.sentReceipts?.concat(this.unsentReceipts)
           .filter(receipt => filterFn(receipt, ...args))
           .sort(this.utils.dynamicSortFn("date"))
           .reverse();
  }

  private markReceiptsAsSent(msg) {
    for (const receipt of msg.data.receipts) {
      const foundReceipts = this.unsentReceipts.filter((p) => p.guid === receipt.guid);
      if (foundReceipts.length === 1) {
        const foundReceipt = foundReceipts[0];
        const idx = this.unsentReceipts.indexOf(foundReceipt);
        this.logger.debug("markReceiptsAsSent", "Found receipt: ", foundReceipts);
        this.unsentReceipts = [...this.unsentReceipts.slice(0, idx), ...this.unsentReceipts.slice(idx + 1)];
        foundReceipt.sentToResto = true;
        this.sentReceipts.push({...foundReceipt, date: new Date(foundReceipt.date)});
        this.writeToStorage();
      } else {
        this.logger.debug("markReceiptsAsSent", "Did not found such receipt: ", foundReceipts);
      }
    }
  }

}
